import { post,put,del,get,get2 } from './axios'

// 관리자관리 CRUD를 나열
export const getCorCombo = async (params) => {
    const { status, data } = await get("/cor/getCorComboAjax", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const selectCorList = async (params) => {
    const { status, data } = await get("/cor/selectCorListAjax", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const selectCorDetail = async (params) => {
    const { status, data } = await get("/cor/selectCorAjax", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const updateStatus = async (params) => {
  const { status, data } = await post("/user/updateStatusAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const updateInactStatus = async (params) => {
  const { status, data } = await post("/user/updateInactStatusAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}